import { atomWithStorage, createJSONStorage } from "jotai/utils";

import { SELECTED_SERVICE_ID } from "@/constants/browserMemory.constants";

const storage = createJSONStorage<number>(() => sessionStorage);
export const selectedClientServiceIdAtom = atomWithStorage<number>(
  SELECTED_SERVICE_ID,
  0,
  storage
);
